var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBaselinePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7925 9.44125C7.0525 11.9175 9.0825 13.9387 11.5588 15.2075L13.4837 13.2825C13.72 13.0463 14.07 12.9675 14.3763 13.0725C15.3562 13.3962 16.415 13.5712 17.5 13.5712C17.9812 13.5712 18.375 13.965 18.375 14.4462V17.5C18.375 17.9812 17.9812 18.375 17.5 18.375C9.28375 18.375 2.625 11.7163 2.625 3.5C2.625 3.01875 3.01875 2.625 3.5 2.625H6.5625C7.04375 2.625 7.4375 3.01875 7.4375 3.5C7.4375 4.59375 7.6125 5.64375 7.93625 6.62375C8.0325 6.93 7.9625 7.27125 7.7175 7.51625L5.7925 9.44125Z",
    fill: "#0038A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselinePhone);
export default __webpack_public_path__ + "static/media/ic_baseline-phone.8a4a5110313405b6e0ba17f0d1b4b42d.svg";
export { ForwardRef as ReactComponent };